import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {SearchOutlined} from '@material-ui/icons';
import t from '../../../i18n/translate';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: '40vh',
		// background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
		padding: theme.spacing(4),
		textAlign: 'center',
	},
	icon: {
		fontSize: 80,
		color: theme.palette.primary.main,
		marginBottom: theme.spacing(2),
		animation: '$fadeIn 1s ease-in-out',
	},
	title: {
		fontWeight: 'bold',
		marginBottom: theme.spacing(1),
		color: theme.palette.text.primary,
	},
	subtitle: {
		marginBottom: theme.spacing(3),
		color: theme.palette.text.secondary,
	},
	button: {
		borderRadius: 50,
		padding: theme.spacing(1, 4),
		textTransform: 'none',
		boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
		transition: 'transform 0.2s',
		'&:hover': {
			transform: 'scale(1.05)',
		},
	},
	'@keyframes fadeIn': {
		from: {opacity: 0},
		to: {opacity: 1},
	},
}));

const EmptyProducts = ({handleClearFilters}) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<SearchOutlined className={classes.icon}/>
			<Typography variant="h4" className={classes.title}>
				{t('no_products_found')}
			</Typography>
			<Typography variant="body1" className={classes.subtitle}>
				{t("try_adjusting_your_filters_or_search_criteria")}
			</Typography>
			<Button
				variant="contained"
				color="primary"
				className={classes.button}
				onClick={handleClearFilters}
			>
				{t('shop_item_filter_clear_button')}
			</Button>
		</div>
	);
};

export default EmptyProducts;